import { ListItem, IconButton, ListItemAvatar, Avatar, ListItemText } from "@mui/material";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

interface Props {
  icon: JSX.Element;
  onArrowClick: () => void;
  primaryText: string;
  secondaryText: string;
}

const ListItemDesktop = ({icon, onArrowClick, primaryText, secondaryText}: Props) => (
  <ListItem
    sx={{ display: { xs: "none", md: "flex" } }}
    secondaryAction={
      (
        <IconButton
          edge="end"
          onClick={onArrowClick}
        >
          <ArrowCircleRightIcon fontSize="large" />
        </IconButton>
      )
    }
  >
    <ListItemAvatar>
      <Avatar>
        {icon}
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={primaryText} secondary={secondaryText} />
  </ListItem>
);

export default ListItemDesktop;
